import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import CountriesTable from './CountriesTable';

interface ICountriesProps extends RouteComponentProps<{
  eshop: string;
  countryId: string;
}> {

}

export default class Countries extends React.Component<ICountriesProps> {

  render() {
    return (
      <div>
        <CountriesTable
          domain={this.props.match.params.eshop}
          countryId={this.props.match.params.countryId}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/scenes/Countries/index.tsx